import { render, staticRenderFns } from "./CustomerWsuView.vue?vue&type=template&id=bae034ac&scoped=true&"
import script from "./CustomerWsuView.vue?vue&type=script&lang=js&"
export * from "./CustomerWsuView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae034ac",
  null
  
)

export default component.exports